import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import styles from "./slide-in.module.scss";

function SlideIn({ children }) {
  const el = useRef(null);
  const [animating, setAnimating] = useState(true);
  const [containerStyles, setContainerStyles] = useState({});
  const handleTranstionEnd = () => {
    if (el.current) {
      el.current.removeEventListener("transitionend", handleTranstionEnd);
    }
    setAnimating(false);
  };

  useEffect(() => {
    const contentHeight = el.current.scrollHeight;
    setContainerStyles({ height: contentHeight, opacity: 1 });
    el.current.addEventListener("transitionend", handleTranstionEnd);

    return handleTranstionEnd;
  }, []);

  return animating ? (
    <div ref={el} style={containerStyles} className={styles["slide-in"]}>
      {children}
    </div>
  ) : (
    children
  );
}

SlideIn.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default SlideIn;
